<template>
    <DealsSection :blok="blok" />
</template>

<script setup lang="ts">
import DealsSection from '~/components/sections/DealsSection.vue';
import type { IDealsSection } from '~/../types/Deals';

defineProps<{ blok: IDealsSection }>();
</script>

<style lang="postcss" scoped></style>
